export default "assets/images/icons/close-26277ad4.svg";